import { EVENTS } from '../../../bus/events.const';
import { COMPONENTS } from '../../../components/components.registry';
import { IdentifierSuggestionsConfig } from '../../../models';

export const DEFAULT_IDENTIFIER_SUGGESTIONS_CONFIG: IdentifierSuggestionsConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    item: COMPONENTS.PURE.ResultSuggestion,
    result: COMPONENTS.SMART.ConfigurableResult
  },
  clickEvents: {
    click: EVENTS.ResultClicked,
    rightClick: EVENTS.ResultRightClicked
  },
  size: 10,
  regex: {
    identifierDetection: '^[0-9]{2,}',
    identifierChars: '\\d',
    separatorChars: '\/?'
  }
};
